<template lang="pug">
#collapse
    .card.mb-3
        //- Header
        .card-header(
            data-toggle='collapse',
            :data-target='getId',
            @click='isCollapsed = !isCollapsed'
        )
            .d-flex.align-items-center
                i.mdi.icon-collapse(:class='getIcon')

                h3 {{ tipoRestricao.nome }}

                span.badge.badge-pill.badge-warning.ml-4(v-if='hasRestricao') Inconsistências encontradas

                i.mdi.mdi-chevron-right.ml-auto(v-if='isCollapsed')
                i.mdi.mdi-chevron-down.ml-auto(v-else)

        .collapse(:id='id')
            //- Body
            .card-body
                slot(name='restricao', v-if='hasRestricao')

                slot(name='infoSemRestricao', v-else-if='visivelSemRestricao')

                empty-result(
                    v-else,
                    :message='mensagemResultadoVazio',
                    iconClass='mdi-check-circle-outline'
                )

            //- Footer
            .card-footer(v-if='hasRestricao')
                .d-flex.align-items-center.texto-fonte-dados
                    i.mdi.mdi-file-check

                    label(@click='toggleFonte') Fonte dos dados

                form(v-if='exibirFonte')
                    .row
                        .col-3
                            div
                                label.mr-1 Fonte:
                            p {{ tipoRestricao.fonte.nome }}
                        .col-6
                            div
                                label.mr-1 URL:
                            a(:href='tipoRestricao.fonte.url', target='_blank') {{ tipoRestricao.fonte.url }}
                        .col-3
                            div
                                label.mr-1 Atualizado em:
                            p {{ tipoRestricao.fonte.dataCadastro }}
</template>
<script>
import EmptyResult from './EmptyResult';
export default {
    name: 'CollapseRestricao',
    components: {
        EmptyResult
    },
    props: {
        tipoRestricao: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        mensagemResultadoVazio: {
            type: String,
            default: 'Não foram detectadas sobreposições.'
        },
        visivelSemRestricao: {
            type: Boolean,
            default: false
        },
        showLabelRestricao: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isCollapsed: true,
            exibirFonte: false
        };
    },
    computed: {
        getIcon() {
            return this.hasRestricao
                ? 'mdi-alert-outline text-warning'
                : 'mdi-check-circle-outline text-success';
        },
        getId() {
            return `#${this.id}`;
        },
        hasRestricao() {
            return (
                this.tipoRestricao.restricoes &&
                this.tipoRestricao.restricoes.length
            );
        }
    },
    methods: {
        toggleFonte() {
            this.exibirFonte = !this.exibirFonte;
        }
    }
};
</script>
<style lang="scss" scoped>
.card-header {
    cursor: pointer;
    background-color: var(--white);
    height: 56px;

    > div {
        height: 100%;
    }
}

i {
    font-size: map-get($font-size-icon, medium);
}

.icon-collapse {
    margin-right: 15px;
}

.titulo-collapse {
    font-size: map-get($font-size, big);
}

.card-footer {
    .texto-fonte-dados {
        display: flex;
        align-items: center;

        i {
            margin-right: 8px;

            color: var(--primary);

            font-size: map-get($font-size-icon, small);
        }

        label {
            margin-bottom: 0;

            color: var(--primary);

            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
